import { TenantEntity } from '../TenantEntity'
export class PartnerNumberAllocation extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid || ''
  }
  get numberAllocationLimit() {
    return this._data.numberAllocationLimit
  }
  set numberAllocationLimit(numberAllocationLimit) {
    this._data.numberAllocationLimit = numberAllocationLimit || 0
  }
}
